import * as types from '../const/action.types';

export function reference(state = {}, action) {
    switch (action.type) {
        case types.LOAD_REFERENCE_SUCCESS:
            return action.data;
        case types.LOG_OUT:
            return {};
        default:
            return state;
    }
}

export function references(state = [], action) {
    switch (action.type) {
        case types.REFERENCES_SUCCESS:
            return action.data;
        default:
            return state;
    }
}

export function referencesHasErrored(state = { hasErrored: false, error: '' }, action) {
    switch (action.type) {
        case types.REFERENCE_HAS_ERROR:
            return {
                hasErrored: action.hasErrored,
                error: action.error,
            };

        default:
            return state;
    }
}

export function referencesIsLoading(state = false, action) {
    switch (action.type) {
        case types.REFERENCES_IS_LOADING:
            return action.isLoading;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/references.reducer.js